import Decimal from "@/utils/decimal";
import { GQL_NorwegianVatSymbolEnum } from "@/queries/global";

interface INowegianVatRate {
  symbol: GQL_NorwegianVatSymbolEnum;
  rate: Decimal;
  startDate: string | null;
  endDate: string | null;
}

/**
 * Takes the list of NorwegianVatRates.
 * Returns all active vat rates based on `date`.
 */
export const filterActiveNorwegianVatRates = (
  vatRates: INowegianVatRate[],
  date: string,
) => vatRates
  .filter(rate =>
    (!rate.startDate || rate.startDate <= date) &&
    (!rate.endDate || rate.endDate >= date),
  );

export const getCorrectVatRate = (
  activeVatRates: INowegianVatRate[],
  symbol: string,
  isExport: boolean,
  isVatRegulated: boolean,
) => {
  if (!isVatRegulated) {
    return activeVatRates.find(v => v.symbol === GQL_NorwegianVatSymbolEnum.EXEMPT);
  } else if (isExport) {
    return activeVatRates.find(v => v.symbol === GQL_NorwegianVatSymbolEnum.ZERO);
  } else {
    return activeVatRates.find(v => v.symbol === symbol);
  }
};
